module.exports = __webpack_public_path__ + "static/img/BoycottBarImage@3x.2459ac4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pride/places/BoycottBarImage@3x.png
// module id = u2jm
// module chunks = 0